import React, { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
const ContextMenuAddress= ({ index, lat, lng, value, copyToClipboard }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleContextMenu = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div onContextMenu={handleContextMenu} index={index}>
      <Link target="_blank" to={`/maps/${lat}/${lng}`}>
        {value ? parse(value) : null}
      </Link>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        style={{ zIndex: 9 }}
      >
        <MenuItem onClick={() => window.open(`/maps/${lat}/${lng}`, "_blank")}>
          View on Map
        </MenuItem>
        <MenuItem onClick={() => copyToClipboard({ text: `${lat},${lng}` })}>
          Copy coordinates
        </MenuItem>
        <MenuItem onClick={() => copyToClipboard({ text: parse(value) })}>
          Copy Address
        </MenuItem>
      </Menu>
    </div>
  );
};

export default ContextMenuAddress;
